import styled from 'styled-components';

const ArticleImage = styled.img`
  height: 214px;
  width: 100%;
  object-fit: cover;
`;

export default ArticleImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/ArticleSlide/ArticleImage.jsx